import React from 'react';
import List from './List';

export default function Tab() {
    return <List />;
}
